/**
 * Relative "from now" formatting matching moment.js's default thresholds
 * (https://momentjs.com/docs/#/displaying/fromnow/), so dates render exactly
 * like the main app's react-moment output.
 */
export function formatFromNow(date: string | number | Date): string {
    const ms = Date.now() - new Date(date).getTime();
    const seconds = Math.round(ms / 1000);
    const minutes = Math.round(seconds / 60);
    const hours = Math.round(minutes / 60);
    const days = Math.round(hours / 24);
    const months = Math.round(days / 30.44);
    const years = Math.round(days / 365.25);

    if (seconds < 45) return "a few seconds ago";
    if (seconds < 90) return "a minute ago";
    if (minutes < 45) return `${minutes} minutes ago`;
    if (minutes < 90) return "an hour ago";
    if (hours < 22) return `${hours} hours ago`;
    if (hours < 36) return "a day ago";
    if (days < 26) return `${days} days ago`;
    if (days < 46) return "a month ago";
    if (days < 320) return `${months} months ago`;
    if (days < 548) return "a year ago";
    return `${years} years ago`;
}

/** Full date like moment's "LLLL" format, e.g. "Thursday, September 4, 1986 8:30 PM". */
export function formatFullDate(date: string | number | Date): string {
    return new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
    }).format(new Date(date));
}
